import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldOther} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldOther;
}

interface Props {
  block: Block;
}

const dataTypes: {[key: string]: any} = {
  text: 'text',
  number: 'number',
  date: 'date',
};

export default ({block}: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);
  const blockable = block.formBlockable;
  const dataType = dataTypes[blockable.dataType];
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorMessage = error?.message;

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.type = dataType;
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLInputElement>) => {
    e.currentTarget.type = dataType;
  };

  return (
    <div className="w-full">
      <div className="flex gap-1 mb-2 items-center">
        <label className="tracking-wide font-bold">{blockable.title}</label>
        {blockable.isRequired && <span className="text-red-500">*</span>}
      </div>
      <input
        className="form-input block w-full border rounded placeholder-c-lighter"
        placeholder={blockable.placeholder}
        type="text"
        ref={ref}
        onFocus={handleFocus}
        onTouchStart={handleTouchStart}
        {...register(block.id)}
        onBlur={(e) => {
          register(block.id).onBlur(e);
          e.target.type = 'text';
        }}
      />
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
      {blockable.helpText && (
        <div className="text-c-light text-sm whitespace-pre-wrap">
          {blockable.helpText}
        </div>
      )}
    </div>
  );
};
